import Button from "../../components/Button"


export default function TemplatesFilterBlock(props:any) {

    const {filterObj, setFilterObj, setQueryObj} = props

    function handleChange(value: string, name: string) {
        setFilterObj((prevState: any) => {
            return {...prevState, [name as keyof typeof prevState]: value}
        })
    }

    function handleClick(event: any) {
        window.history.replaceState(null, '', `../templates/1`)

        if (event.target.name === 'Search' || event.key === 'Enter') {
            setQueryObj((prevState: any) => {
                return {...prevState, filterObj: filterObj, currentPage: 1}
            })
        } else {
            for (let k in filterObj) {
                filterObj[k as keyof typeof filterObj] = ''
            }
            setQueryObj((prevState: any) => {
                return {...prevState, filterObj: filterObj, currentPage: 1}
            })
        }
    }

    return (

        <div className="filter-base-container template-grid-filter">

            <div className="trg-subcont">
                <div className="field-label">Taxonomy name</div>
                <input
                    name="taxName"
                    type="text"
                    className="filter-input"
                    onChange={(event) => handleChange(event.target.value, event.target.name)}
                    onKeyDown={(event) => event.key === 'Enter' ? handleClick(event) : ''}
                    value={filterObj.taxName}
                    disabled
                />
            </div>

            <div className="trg-subcont">
                <div className="field-label">Template name</div>
                <input
                    name="tmplName"
                    type="text"
                    className="filter-input"
                    onChange={(event) => handleChange(event.target.value, event.target.name)}
                    onKeyDown={(event) => event.key === 'Enter' ? handleClick(event) : ''}
                    value={filterObj.tmplName}
                />
            </div>

            <div className="btn-container">
                {/*<Button type="primary" text="Search" onclick={handleClick}/>*/}
                <Button type="primary" text="Search" onclick={(event: any) => handleClick(event)}/>
            </div>

            <div className="btn-container">
                <Button type="secondary" text="Clear" onclick={(event: any) => handleClick(event)}/>
            </div>

        </div>

    )
}
